import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
export type GetCollectionEventImageRequest = {
  collectionEventId: number;
  collectionEventType: number;
};

export type GetCollectionEventImageResponse = {
  imgSrc: string;
  imageType: string;
};

export const getCollectionEventImage = async (request: GetCollectionEventImageRequest) => {
  const defaultImage: GetCollectionEventImageResponse = {
    imgSrc: "https://via.placeholder.com/350x150.png?text=Unable+to+load+image",
    imageType: "png"
  };
  try {
    const response = await executeApiRequest(
      () => axios.get<GetCollectionEventImageResponse>(`/collectionevents/${request.collectionEventId}/image?collectionEventType=${request.collectionEventType}`),
      false
    );

    return response?.data || defaultImage;
  } catch (error) {
    return defaultImage;
  }
};
